import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { ArrowDown, ArrowUp } from "lucide-react";
import React from "react";

export enum StockStatus {
    PENDING = "Pending",
    APPROVED = "Approved",
    REJECTED = "Rejected",
    RECEIVED = "Received"
}

export enum StockTakingType {
    REQUEST = "Request",
    RECEIVE = "Receive"
}

export interface StockItemData {
    name: string;
    request_from: string;
    quantity: number;
    status: StockStatus;
    type: StockTakingType;
    created_at: string;
}

interface RequestAndReceiveCardProps extends StockItemData {}

const RequestAndReceiveCard: React.FC<RequestAndReceiveCardProps> = ({
    name,
    request_from,
    quantity,
    status,
    type,
    created_at
}) => {
    const getStatusBadgeClass = () => {
        if (status === StockStatus.APPROVED || status === StockStatus.RECEIVED) {
            return "bg-green-100 text-green-600 font-medium";
        } else if (status === StockStatus.PENDING) {
            return "bg-yellow-100 text-yellow-600 font-medium";
        } else {
            return "bg-red-600 text-white";
        }
    };

    return (
        <Card className="w-full border rounded-lg">
            <CardContent className="flex flex-col items-center justify-center p-4">
                <div className="flex flex-row items-center justify-between w-full">
                    <div className="flex flex-row items-center justify-start gap-x-4">
                        {type === StockTakingType.REQUEST ? (
                            <ArrowUp className="text-blue-500" />
                        ) : (
                            <ArrowDown className="text-green-500" />
                        )}
                        <div className="flex flex-col items-start justify-center gap-y-1">
                            <span className="font-medium text-lg">{name}</span>
                            <span className="font-normal text-gray-400 text-sm">
                                {type === StockTakingType.REQUEST ? "Requested By" : "Supplier"}: {request_from}
                            </span>
                            <span className="font-normal text-gray-400 text-xs">Date: {created_at}</span>
                        </div>
                    </div>
                    <div className="flex flex-col items-end justify-center">
                        <span className="font-medium">Qty: {quantity}</span>
                        <Badge className={getStatusBadgeClass()}>{status}</Badge>
                    </div>
                </div>
                {status === StockStatus.APPROVED && type === StockTakingType.REQUEST && (
                    <div className="w-full">
                        <Separator className="my-4" />
                        <div className="flex flex-row items-center justify-start gap-x-2">
                            <Button variant="outline" className="h-[35px] rounded-[12px]">
                                Reject
                            </Button>
                            <Button className="h-[35px] rounded-[12px]">
                                Approve
                            </Button>
                        </div>
                    </div>
                )}
            </CardContent>
        </Card>
    );
};

export default RequestAndReceiveCard;
